import {
	Box,
	Button,
	Card,
	Divider,
	IconButton,
	List,
	ListItem,
	Modal,
	Stack,
	Typography,
} from "@mui/material"
import { useEffect, useState } from "react"
import NewWorkspaceForm from "./NewWorkspaceForm"
import { useDispatch, useSelector } from "react-redux"
import {
	openPrimaryWorkspace,
	selectWorkspace,
} from "../../reducers/workspaceSlice"
import { selectUser } from "../../reducers/userSlice"
import axios from "axios"
import {Close} from "@mui/icons-material"
import {closeWorkspaceManager, selectWorkspaceManagerOpen} from "../../reducers/dashboardModalControlSlice"

export default function Manager() {
	const currentWorkspace = useSelector(selectWorkspace)
	const workspaceManagerIsOpen = useSelector(selectWorkspaceManagerOpen)
	const open = currentWorkspace === null || workspaceManagerIsOpen
	const dispatch = useDispatch()
	const close = () => dispatch(closeWorkspaceManager())
	const user = useSelector(selectUser)
	const [createNewWorkspace, setCreateNewWorkspace] = useState(false)
	const [userWorkspaces, setUserWorkspaces] = useState([])
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState(null)
	
	const fetchUserWorkspaces = async () => {
		setIsLoading(true)
		setError(null)
		try {
			const { data } = await axios.get("/api/workspace/userWorkspaces")
			setUserWorkspaces(data)
		} catch (e) {
			console.error("Error fetching workspaces:", e)
			setError(e)
		} finally {
			setIsLoading(false)
		}
	}
	useEffect(() => {
		if(user) {
			fetchUserWorkspaces()
		}
	},[open, user])

	const afterCreateNewWorkspace = async (workspaceObj) => {
		await openPrimaryWorkspace({workspace: workspaceObj})
		setCreateNewWorkspace(false)
		close()
	}

	if (isLoading || !user) {
		return <div>Loading workspaces...</div>
	}
	
	if (error) {
		return <div>Error fetching workspaces. Please refresh the page and try again.</div>
	}

	if (createNewWorkspace) {
		return (
			<Modal open={open}>
				<Box className={"modal-container"} sx={{ textAlign: "center" }}>
					<Button
						onClick={() => setCreateNewWorkspace(false)}
						sx={{ position: "absolute", right: 0, display: "inline-flex" }}
					>
						Cancel
					</Button>
					<Box>
						<Typography id="modal-modal-title" variant="h4">
							New Workspace
						</Typography>
					</Box>
					<NewWorkspaceForm afterCreate={afterCreateNewWorkspace} />
				</Box>
			</Modal>
		)
	}

	if (userWorkspaces.length) {
		return (
			<Modal open={open}>
				<Box className={"modal-container"} sx={{ textAlign: "center" }}>
					{
						//Manager is unable to be closed if currentWorkspace isn't set
						currentWorkspace !== null && (
							<IconButton
								onClick={close}
								sx={{
									position: "absolute",
									top: 0,
									right: 0,
									maxHeight: "50px",
									zIndex: 10,
								}}
							>
								<Close />
							</IconButton>
						)
					}
					<Typography id="modal-modal-title" variant="h4">
						Workspaces
					</Typography>
					<br />
					<List
						sx={{
							margin: 0,
							padding: 1,
							maxHeight: "300px",
							borderRadius: "5px",
							overflowY: "scroll",
							background: "#00000017",
						}}
					>
						{userWorkspaces.map(({ read, write, admin, workspace, ownerIsFreeTier, ownerIsSuperadmin, }) => {
							return (
								<ListItem
									key={workspace.id}
									sx={{ padding: "5px" }}
									onClick={() =>
										dispatch(openPrimaryWorkspace({
											...workspace,
											permissions: { read, write, admin },
											ownerIsFreeTier,
											ownerIsSuperadmin,
										}))
									}
								>
									<Card elevation={2} sx={{ 
										width: "100%", 
										padding: "5px 10px",
										transition: "all .3s ease-in-out",
										cursor: "pointer",
										"&:hover" : {
											backgroundColor: "#c8ecf0"
										}}}>
										<Typography variant={"h6"} textAlign={"center"}>
											{workspace.title}
										</Typography>
										<Divider sx={{ width: "50%", margin: "auto" }} />
										<Typography variant={"subtitle1"}>
											{workspace.description}
										</Typography>
									</Card>
								</ListItem>
							)
						})}
					</List>
					<br />
					<Button
						variant={"contained"}
						sx={{ marginRight: "10px" }}
						onClick={() => setCreateNewWorkspace(true)}
					>
						Create New Workspace
					</Button>
				</Box>
			</Modal>
		)
	}

	return (
		<Modal open={open}>
			<Box className={"modal-container"} sx={{ textAlign: "center" }}>
				<Stack spacing={1}>
					<Typography id="modal-modal-title" variant="h4">
						Welcome to Refbin!
					</Typography>
					<Typography id="modal-modal-description" sx={{ mt: 2 }}>
						Let's get started by creating a workspace.
					</Typography>
					<NewWorkspaceForm afterCreate={() => close()} />
				</Stack>
			</Box>
		</Modal>
	)
}